$(function () {
  function pf_scroll_to_element($elem, duration, offset) {
    offset = offset || 0;
    duration = duration || 500;
    $('html,body').stop().animate({scrollTop: $elem.offset().top - offset}, duration)
  }

  function pf_update_input_feedback($fields) {
    $fields.each(function () {
      const $this = $(this);
      const $feedback = $this.siblings('.invalid-feedback');
      const data = $feedback.data();
      for (let key in this.validity) {
        const k = 'validation' + (key.charAt(0).toUpperCase() + key.slice(1));
        if (this.validity[key] && data && data.length && data[k]) {
          $feedback.html(data[k])
        }
      }
    })
  }

  $(document.body).on('pf-form-submit', 'form.needs-validation', function (e, trigger_submit) {
    const $this = $(this);
    if (!this.checkValidity()) {
      const $fields = $this.find(':invalid');
      pf_update_input_feedback($fields);
      pf_scroll_to_element($fields.eq(0), 500, 100)
    } else {
      trigger_submit()
    }
    $this.addClass('was-validated')
  });
  $(document.body).on('change', 'form input,form textarea,form select', function () {
    pf_update_input_feedback($(this))
  });
  $(document.body).on('click', 'form .form-submit', function () {
    const $this = $(this);
    const $form = $this.parents('form').eq(0);
    const trigger_submit = function () {
      $form.find('[type="submit"]').trigger('click')
    }
    $form.trigger('pf-form-submit', [trigger_submit])
  });

  document.body.addEventListener('pf_cart_change', function(e) {
    pf_shipping_timeline_warnings(e.detail.products);
  });

  function pf_track_cart_updates() {
    const target = document.querySelector('#dropdown-cart .mini-products-list');
    if (!target) {
      return;
    }

    const trigger_updates = function (wrapper) {
      const products = [];
      if (!wrapper || !wrapper.children) {
        return;
      }

      Array.from(wrapper.children).forEach(function(item) {
        const id_match = item.id.match(/cart-item-([0-9]+)/);

        products.push({
          id: id_match[1] || ''
        });
      });

      document.body.dispatchEvent(new CustomEvent('pf_cart_change', {
        detail: {
          products: products
        }
      }));
    }

    const observer = new MutationObserver(function () {
      trigger_updates(target);
    });

    trigger_updates(target);
    observer.observe(target, {
      childList: true
    });
  }
  pf_track_cart_updates();

  function pf_shipping_timeline_warnings(products) {
    const timeline_warnings = document.querySelectorAll('.shipping-timeline-warning');
    if (!timeline_warnings || !timeline_warnings.length) {
      return;
    }

    const skip_products = JSON.parse(timeline_warnings[0].dataset.skipProducts);
    const product_ids = products.map(function(product) {
      return product.id;
    }).filter(function(id) {
      return skip_products.indexOf(id) === -1;
    });
    const hide_warning = product_ids.length < 2;

    timeline_warnings.forEach(function(warning) {
      warning.style.display = hide_warning ? 'none' : 'block';
    });
  }
})